"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailAuthSelectors = exports.createAuthItemSelector = void 0;

var _reselect = require("reselect");

var _PqlUpgradeProduct = _interopRequireDefault(require("EmailData/enums/pqls/PqlUpgradeProduct"));

var _functionUtils = require("EmailData/utils/functionUtils");

var _EmailTypeHelpers = require("EmailData/helpers/EmailTypeHelpers");

var _constants = require("EmailData/utils/constants");

var createAuthItemSelector = function createAuthItemSelector(authItemsSelector, authItem) {
  return (0, _reselect.createSelector)(authItemsSelector, function (authItems) {
    return authItems.indexOf(authItem) > -1;
  });
};

exports.createAuthItemSelector = createAuthItemSelector;

var getEmailAuthSelectors = function getEmailAuthSelectors(getGates, getScopes) {
  var getPortalSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var getCanUseTransactional = createAuthItemSelector(getScopes, 'transactional-email-bulk');
  var getHasEmailBlogOnlyAccess = createAuthItemSelector(getGates, 'Email:BlogEmailOnlyAccess');

  var getEmailTypeScopes = function getEmailTypeScopes(gates) {
    return gates.includes('Email:BlogEmailOnlyAccess') ? _EmailTypeHelpers.EMAIL_TYPE_SCOPES : _EmailTypeHelpers.OLD_EMAIL_TYPE_SCOPES;
  };

  var emailTypesAuthedFor = function emailTypesAuthedFor(scopes, gates) {
    var emailTypeScopes = getEmailTypeScopes(gates);
    return Object.keys(emailTypeScopes).filter(function (emailType) {
      return scopes.indexOf(emailTypeScopes[emailType]) > -1;
    });
  };

  var hasAccessToAnEmailType = function hasAccessToAnEmailType(scopes, gates) {
    return emailTypesAuthedFor(scopes, gates).length > 0;
  };

  var getHasAccessToSomeEmailType = (0, _reselect.createSelector)([getScopes, getGates], hasAccessToAnEmailType);
  var getEmailTypesAuthedFor = (0, _reselect.createSelector)([getScopes, getGates], emailTypesAuthedFor);
  var getHasEmailEditorAccess = createAuthItemSelector(getScopes, 'email-editor-access');
  var getHasCoreContentAccess = createAuthItemSelector(getScopes, 'content-core-api-access');
  var getHasMarketingEmailProduct = createAuthItemSelector(getScopes, 'email-marketing-product-access');
  var getHasEditorOnboarding = createAuthItemSelector(getGates, 'Email:EditorOnboarding');
  var getHasEditorBpeOnboarding = createAuthItemSelector(getGates, 'Email:EditorOnboardingBPE');
  var getHasUnpaidExperience = (0, _reselect.createSelector)([getHasMarketingEmailProduct, getHasEmailEditorAccess, getHasCoreContentAccess], function (hasMarketingEmailProduct, hasEmailEditorAccess, hasContentCoreAccess) {
    return hasMarketingEmailProduct && !hasContentCoreAccess && hasEmailEditorAccess;
  });
  var getHasFreeEmail = getHasUnpaidExperience;
  var getHasEmailSendingStarter = createAuthItemSelector(getScopes, 'email-sending-starter');
  var getHasFullEditorAccess = createAuthItemSelector(getScopes, 'email-full-editing');
  var getHasEmailAccess = createAuthItemSelector(getScopes, 'email-access');
  var getHasEmailWriteScope = createAuthItemSelector(getScopes, 'email-write');
  var usingEmailStarter = (0, _reselect.createSelector)([getHasMarketingEmailProduct, getHasEmailSendingStarter], function (hasMarketingEmailProduct, hasEmailSendingStarter) {
    return hasMarketingEmailProduct && hasEmailSendingStarter;
  });
  var getHasOnboarding = (0, _reselect.createSelector)([getHasEditorBpeOnboarding, getHasEditorOnboarding, getHasFreeEmail, usingEmailStarter], function (hasEditorBpeOnboarding, hasEditorOnboarding, isFreeEmail, isStarterEmail) {
    return hasEditorBpeOnboarding || hasEditorOnboarding && (isFreeEmail || isStarterEmail);
  });
  var getCanUseLocalTime = createAuthItemSelector(getScopes, 'email-localtime');
  var getHasEmailWritePermissions = getHasEmailWriteScope;
  var getHasPermissionsToLoadEditor = (0, _reselect.createSelector)([getHasMarketingEmailProduct, getHasEmailEditorAccess, getHasAccessToSomeEmailType], function (hasMarketingEmailProduct, hasEmailEditorAccess, _hasAccessToAnEmailType) {
    return hasEmailEditorAccess && (hasMarketingEmailProduct || _hasAccessToAnEmailType);
  });
  var getUngatedForNewLists = createAuthItemSelector(getGates, 'Contacts:SegmentsUI');
  var getHasLitmusAccess = (0, _reselect.createSelector)([getHasFullEditorAccess, getHasEmailWritePermissions], function (fullEditorAccess, emailWritePermission) {
    return fullEditorAccess && emailWritePermission;
  });
  var getCanHaveMultipleOfficeLocations = createAuthItemSelector(getScopes, 'multiple-office-locations');
  var getIsUngatedForNewEmailEditorFlow = createAuthItemSelector(getGates, 'Email:NewFlow:Editor');
  var getIsUngatedForNewEmailEditorValidationFlow = createAuthItemSelector(getGates, 'Email:NewFlow:Editor:Validation');
  var getIsUngatedForNewEmailBlogRssFlow = createAuthItemSelector(getGates, 'Email:NewFlow:BlogRss');
  var getIsUngatedForEnforcedTestSendVerification = createAuthItemSelector(getGates, 'Email:EnforceTestSendVerification');
  var getHasEnforcedTestSendVerification = (0, _reselect.createSelector)([getIsUngatedForEnforcedTestSendVerification, getHasEmailAccess], function (ungatedForEnforced, hasEmailAccess) {
    return ungatedForEnforced || !hasEmailAccess;
  });
  var getHasContentAbTesting = createAuthItemSelector(getScopes, 'content-ab-testing');
  var getHasContentSettings = createAuthItemSelector(getScopes, 'content-settings-access');
  var getHasCampaignsAccess = createAuthItemSelector(getScopes, 'campaigns-access');
  var getHasCanSpamSettings = createAuthItemSelector(getScopes, 'can-spam-settings-access');
  var getHasContactsListAccess = createAuthItemSelector(getScopes, 'contacts-lists-access');
  var getHasEmailSelectRecipientsAccessScope = createAuthItemSelector(getScopes, 'email-select-recipients');
  var getHasEmailMultiSubscriptionsAccess = createAuthItemSelector(getScopes, 'email-multi-subscriptions-access');
  var getCanTestSendToAnyAddress = createAuthItemSelector(getScopes, 'email-test-sending-any-address');
  var getHasWorkflowsEmailAccessScope = createAuthItemSelector(getScopes, 'workflows-email-access');

  var _getHasBlogEmailAccess = createAuthItemSelector(getScopes, 'email-type-blog-access');

  var _getOldHasBlogEmailAccess = createAuthItemSelector(getScopes, 'email-batch-rss-blog');

  var getHasBlogEmailAccess = (0, _reselect.createSelector)([getHasEmailBlogOnlyAccess, _getHasBlogEmailAccess, _getOldHasBlogEmailAccess], function (isUngated, newBlogAccess, oldBlogAccess) {
    return isUngated ? newBlogAccess : oldBlogAccess;
  });
  var getHasRssEmailAccess = createAuthItemSelector(getScopes, 'email-type-rss-access');
  var getHasSupportAccessSelector = createAuthItemSelector(getScopes, 'zorse-support-inbox-access');
  var getHasRemediationWithZorse = createAuthItemSelector(getGates, 'Email:SuspensionBannerWithZorse'); //TODO remove from ContentEmailUI then safely remove here

  var getHasBlogRssAccess = (0, _functionUtils.allTrueFunctions)([getHasBlogEmailAccess, getHasRssEmailAccess]);
  var getHasNewBlogRssAccess = (0, _functionUtils.allTrueFunctions)([getHasBlogRssAccess, getIsUngatedForNewEmailBlogRssFlow]);
  var getHasDragDropAB = getHasContentAbTesting;
  var getHasFatigueSuppressionAccess = createAuthItemSelector(getScopes, 'email-recipient-fatigue-suppression-access');

  var canCreateDragDropEmail = function canCreateDragDropEmail(gates, scopes, portalSettings) {
    var hasEmailEditorAccess = scopes.indexOf('email-editor-access') >= 0;
    if (!hasEmailEditorAccess) return false;
    var isOptedIn = false;

    if (portalSettings && portalSettings.length) {
      var notOptedInAttr = portalSettings.find(function (s) {
        return s.key === _constants.ICEBERGER_NOT_OPTED_IN_PORTAL_SETTING;
      });

      if (notOptedInAttr) {
        isOptedIn = notOptedInAttr.value !== 'true';
      } else {
        isOptedIn = true;
      }
    } else {
      isOptedIn = true;
    }

    var hasScopesForAnyEmailType = emailTypesAuthedFor(scopes, gates).length > 0;
    return hasScopesForAnyEmailType && isOptedIn;
  };

  var canCreateClassicEmail = function canCreateClassicEmail(scopes) {
    return scopes.indexOf('email-access') > -1;
  };

  var getCanCreateClassicEmail = (0, _reselect.createSelector)([getScopes], canCreateClassicEmail);
  var getCanCreateDragDropEmail = (0, _reselect.createSelector)([getGates, getScopes, getPortalSettings], canCreateDragDropEmail);
  var getDragDropEmailAvailable = (0, _reselect.createSelector)([getHasMarketingEmailProduct, getCanCreateDragDropEmail], function (hasMarketingEmailProduct, canCreateDragDrop) {
    return hasMarketingEmailProduct && canCreateDragDrop;
  });
  var getHasCrmImportScope = createAuthItemSelector(getScopes, 'crm-import');
  var getPqlUpgradeProduct = (0, _reselect.createSelector)([getHasFreeEmail, usingEmailStarter], function (isFreeEmail, isEmailStarter) {
    if (isEmailStarter) {
      return _PqlUpgradeProduct.default.MARKETING_PROFESSIONAL;
    } else if (isFreeEmail) {
      return _PqlUpgradeProduct.default.MARKETING_STARTER;
    }

    return _PqlUpgradeProduct.default.MARKETING_ENTERPRISE;
  });
  return {
    getCanUseTransactional: getCanUseTransactional,
    getHasEmailEditorAccess: getHasEmailEditorAccess,
    getHasCoreContentAccess: getHasCoreContentAccess,
    getHasFullEditorAccess: getHasFullEditorAccess,
    getHasEmailWriteScope: getHasEmailWriteScope,
    usingEmailStarter: usingEmailStarter,
    getCanUseLocalTime: getCanUseLocalTime,
    getHasEmailWritePermissions: getHasEmailWritePermissions,
    getHasPermissionsToLoadEditor: getHasPermissionsToLoadEditor,
    getUngatedForNewLists: getUngatedForNewLists,
    getHasLitmusAccess: getHasLitmusAccess,
    getCanHaveMultipleOfficeLocations: getCanHaveMultipleOfficeLocations,
    getIsUngatedForNewEmailEditorFlow: getIsUngatedForNewEmailEditorFlow,
    getIsUngatedForNewEmailEditorValidationFlow: getIsUngatedForNewEmailEditorValidationFlow,
    getHasContentAbTesting: getHasContentAbTesting,
    getHasContentSettings: getHasContentSettings,
    getHasCampaignsAccess: getHasCampaignsAccess,
    getHasAccessToSomeEmailType: getHasAccessToSomeEmailType,
    getHasCanSpamSettings: getHasCanSpamSettings,
    getHasContactsListAccess: getHasContactsListAccess,
    getHasBlogEmailAccess: getHasBlogEmailAccess,
    getHasEmailSelectRecipientsAccessScope: getHasEmailSelectRecipientsAccessScope,
    getHasEmailMultiSubscriptionsAccess: getHasEmailMultiSubscriptionsAccess,
    getHasMarketingEmailProduct: getHasMarketingEmailProduct,
    getHasUnpaidExperience: getHasUnpaidExperience,
    getCanTestSendToAnyAddress: getCanTestSendToAnyAddress,
    getHasDragDropAB: getHasDragDropAB,
    getHasEnforcedTestSendVerification: getHasEnforcedTestSendVerification,
    getIsUngatedForNewEmailBlogRssFlow: getIsUngatedForNewEmailBlogRssFlow,
    getHasWorkflowsEmailAccessScope: getHasWorkflowsEmailAccessScope,
    getHasBlogRssAccess: getHasBlogRssAccess,
    getHasNewBlogRssAccess: getHasNewBlogRssAccess,
    getEmailTypesAuthedFor: getEmailTypesAuthedFor,
    getHasReadOnlyFatigueSuppression: getHasFatigueSuppressionAccess,
    getHasFatigueSuppressionAccess: getHasFatigueSuppressionAccess,
    getHasFreeEmail: getHasFreeEmail,
    getHasEditorOnboarding: getHasEditorOnboarding,
    getHasEditorBpeOnboarding: getHasEditorBpeOnboarding,
    getHasOnboarding: getHasOnboarding,
    getHasEmailAccess: getHasEmailAccess,
    canCreateDragDropEmail: canCreateDragDropEmail,
    canCreateClassicEmail: canCreateClassicEmail,
    getCanCreateDragDropEmail: getCanCreateDragDropEmail,
    getDragDropEmailAvailable: getDragDropEmailAvailable,
    getCanCreateClassicEmail: getCanCreateClassicEmail,
    getHasCrmImportScope: getHasCrmImportScope,
    getPqlUpgradeProduct: getPqlUpgradeProduct,
    getHasEmailBlogOnlyAccess: getHasEmailBlogOnlyAccess,
    getHasSupportAccessSelector: getHasSupportAccessSelector,
    getHasRemediationWithZorse: getHasRemediationWithZorse
  };
};

exports.getEmailAuthSelectors = getEmailAuthSelectors;